import Link from 'next/link';
import Image from 'next/image';
import fbsvg from '../images/fb.svg';
import linkedinsvg from '../images/linkedIn.svg';
import youtubesvg from '../images/youtube.svg';
import instagramsvg from '../images/instagram.svg';

import logo from '../images/footer-anacle-logo.svg';

// Add the Footer to the bottom of your landing page and more.
// The support link is connected to the config.js file. If there's no config.mailgun.supportEmail, the link won't be displayed.

const Footer = () => {
  return (
    <footer className="bg-lightGray py-12 mt-8 mx-auto px-8">
      <section className="max-w-8xl grid grid-cols-4 gap-4 mx-auto">
        <div className="col-span-3">
          <Link href="https://anacle.com/">
            <Image
              className="w-auto h-auto"
              src={logo}
              alt="Anacle Systems"
              width="140"
              height="41"
            />
          </Link>
        </div>
      </section>
      <section className="max-w-8xl grid md:grid-cols-3 lg:grid-cols-4 gap-4 mx-auto mt-6">
        <div className="hidden lg:block col-span-1"></div>
        <div className="col-span-1">
          <h5 className="font-bold pb-4 text-lg">Explore Anacle</h5>
          <ul className="text-sm">
            {/* <li className="pb-3">
              <Link href="#">Our Technologies</Link>
            </li> */}
            <li className="pb-3">
              <Link href="https://anacle.com/about-us">About us</Link>
            </li>
            <li className="pb-3">
              <Link href="https://anacle.com/media-2/">Media Room</Link>
            </li>
            <li className="pb-3">
              <Link href="https://anacle.com/investor-relations">
                Investor Relations
              </Link>
            </li>
            <li className="pb-3">
              <Link href="https://anacle.com/investor-relations/financial-reports/">
                Financial Reports
              </Link>
            </li>
            <li className="pb-3">
              <Link href="https://anacle.com/investor-relations/announcements/">
                Announcements
              </Link>
            </li>
            <li className="pb-3">
              <Link href="https://anacle.com/about-us/">Anacle Leadership</Link>
            </li>
            <li className="pb-3">
              <Link href="https://anacle.com/careers/">Careers</Link>
            </li>
          </ul>
        </div>
        <div className="col-span-1">
          <h5 className="font-bold pb-4 text-lg">Products</h5>
          <ul className="text-sm">
            <li className="pb-3">
              <Link href="/">
                Simplicity<sup>®</sup> Business Software
              </Link>
            </li>
            <li className="pb-3">
              <Link href="/real-estate">
                Simplicity<sup>®</sup> Real Estate
              </Link>
            </li>
            <li className="pb-3">
              <Link href="/digital-workplace">
                Simplicity<sup>®</sup> Digital Workplace
              </Link>
            </li>
            <li className="pb-3">
              <Link href="/utilities">
                Simplicity<sup>®</sup> Utilities
              </Link>
            </li>
            {/* <li className="pb-3">
              <Link href="#">
                Simplicity<sup>®</sup> IoT
              </Link>
            </li> */}
            <li className="pb-3">
              <Link href="https://tesseract.anacle.com/">
                Tesseract<sup>®</sup>
              </Link>
            </li>
          </ul>

          <h5 className="font-bold pb-4 text-lg mt-12">Partners</h5>
          <ul className="text-sm">
            <li className="pb-3">
              <Link href="https://channels.anacle.com/">
                Channel Partner Programs
              </Link>
            </li>
            <li className="pb-3">
              <Link href="https://channels.anacle.com/professional-services-providers/">
                Professional Services Providers
              </Link>
            </li>
          </ul>
        </div>
        <div className="col-span-1">
          <h5 className="font-bold pb-4">Locations</h5>
          <p className="text-sm">
            3 Fusionopolis Way, #14-21, Symbiosis, <br />
            Singapore 138633
          </p>
          <p className="flex gap-2 mt-4">
            <Link href="https://www.linkedin.com/company/anacle-systems/">
              <Image src={linkedinsvg} alt="linkedin" />
            </Link>
            <Link href="https://www.facebook.com/AnacleSystems/">
              <Image src={fbsvg} alt="facebook" />
            </Link>
            <Link href="https://www.instagram.com/lifeatanacle/">
              <Image src={instagramsvg} alt="instagram" />
            </Link>
            <Link href="https://www.youtube.com/channel/UCJaI93IYlEItP_pncdY47Bw">
              <Image src={youtubesvg} alt="youtube" />
            </Link>
          </p>
          <ul className="text-sm mt-10">
            <li className="pb-3">
              <Link href="https://anacle.com/contact-us/">Contact Us</Link>
            </li>
            <li className="pb-3">
              <Link href="https://anacle.com/privacy-policy/">
                Privacy Policy
              </Link>
            </li>
          </ul>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
